import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../../../app/token.service';
import { Mainservice2Service } from '../service/mainservice2.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { DomSanitizer } from "@angular/platform-browser";
import { MakingDataService } from 'src/app/md/service/making-data.service';
@Injectable({
  providedIn: 'root'
})
export class PetRegistrationService {

  httpUrl;
  constructor(private http: HttpClient, private main: Mainservice2Service,private token:TokenService,
    private sanitizer: DomSanitizer,private mds : MakingDataService) {
    this.httpUrl = this.main.httpUrl ;
  }
  
  async get_party_data(obj:any){
   let resp = await this.getpartydetail(JSON.stringify(obj));
   console.log(resp)
   if(resp['error'] == false){
    return resp
   }else{
    Swal.fire('error','server side error','error');
    return resp
   }

  }

  async pet_details(obj:any){
    let resp = await this.petdetail(JSON.stringify(obj));
    console.log(resp)
    if(resp['error'] == false){
     return resp
    }else{
     Swal.fire('error','server side error','error');
     return
    }
 
   }
   async complain_details(obj:any){
    let resp = await this.details_on_regid(JSON.stringify(obj));
    console.log(resp)
    if(resp['error'] == false){
     return resp
    }else{
     Swal.fire('error','server side error','error');
     return
    }
 
   }
// ///////////////////view doc //////////////////////////////////
imgURL1 : any;
  async viewdoc(obj:any) {
    let resp = await this.view_document(obj)
    if (resp) {
      var docname = obj.doc_name
      var ext = docname.split(".");
      if (
        ext[1] == "png" ||
        ext[1] == "jpeg" ||
        ext[1] == "jpg" ||
        ext[1] == "PNG" ||
        ext[1] == "JPEG" ||
        ext[1] == "JPG"
      ) {
        let file = new Blob([resp], { type: "image/png" });
        var fileURL = window.URL.createObjectURL(file);
        this.imgURL1 = this.sanitizer.bypassSecurityTrustUrl(fileURL);
       
        window.open(fileURL, "_blank");
      } else if (ext[1].toLowerCase() == "xlsx") {
        let file = new Blob([resp], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        
      } else if (
        ext[1].toLowerCase() == "docx" ||
        ext[1].toLowerCase() == "doc"
      ) {
        let file = new Blob([resp], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        
      } else {
        let file = new Blob([resp], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    } else {
      
    }

  }





  async viewAdminReport(obj:any) {
    let resp = await this.view_admin_report(obj)
    if (resp) {
      var docname = obj.doc_name
      var ext = docname.split(".");
      if (
        ext[1] == "png" ||
        ext[1] == "jpeg" ||
        ext[1] == "jpg" ||
        ext[1] == "PNG" ||
        ext[1] == "JPEG" ||
        ext[1] == "JPG"
      ) {
        let file = new Blob([resp], { type: "image/png" });
        var fileURL = window.URL.createObjectURL(file);
        this.imgURL1 = this.sanitizer.bypassSecurityTrustUrl(fileURL);
       
        window.open(fileURL, "_blank");
      } else if (ext[1].toLowerCase() == "xlsx") {
        let file = new Blob([resp], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        
      } else if (
        ext[1].toLowerCase() == "docx" ||
        ext[1].toLowerCase() == "doc"
      ) {
        let file = new Blob([resp], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        
      } else {
        let file = new Blob([resp], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    } else {
      
    }

  }


  async  getDashboardData(obj:any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/pet/admin_reg/getDashboardData' + JSON.stringify(obj)).toPromise().then(res => {
      return res
    });
    return resp
  }

  async  getDashboardAnalytics(obj:any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/pet/admin_reg/getDashboardAnalytics' + JSON.stringify(obj)).toPromise().then(res => {
      return res
    });
    return resp
  }


  async  getDashboardPieChartAnalytics(obj:any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/pet/admin_reg/getDashboardPieChart' + JSON.stringify(obj)).toPromise().then(res => {
      return res
    });
    return resp
  }


  async  getDashboardLineChart(obj:any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/pet/admin_reg/getDashboardLineChart' + JSON.stringify(obj)).toPromise().then(res => {
      return res
    });
    return resp
  }



  async  getpartydetail(obj:any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/pet/admin_reg/get_party_details' + JSON.stringify({}),{
           headers:
             new HttpHeaders().append('data',await this.mds.dataE(obj))
           }).toPromise().then(async res => {
      return await this.mds.dataD(res);
    });
    return resp
  }

  async  petdetail(obj:any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/pet/admin_reg/pet_details' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }


  async  gettingRevokedVacineDogDetails(obj:any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/pet/admin_reg/gettingRevokedVacineDogDetails' + JSON.stringify(obj)).toPromise().then(res => {
      return res
    });
    return resp
  }



  async  certificate_issue(obj:any) {
    const resp = this.http.post<any>(this.main.httpUrl2 + '/pet/admin_reg/certificate_issue' , obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async cancel_registration(obj:any) {
    const resp = this.http.post<any>(this.main.httpUrl2 + '/pet/admin_reg/cancel_registration' , this.mds.dataE(obj),).toPromise().then(res => {
      return res
    });
    return resp
  }
  async deny_registration(obj:any) {
    const resp = this.http.post<any>(this.main.httpUrl2 + '/pet/admin_reg/deny_registration' , obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async details_on_regid(obj:any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/pet/admin_reg/details_on_regid' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  
  async view_document(obj :any) {
    console.log(obj, "from service")
    const resp = await this.http.post(this.main.httpUrl2 + '/pet/admin_reg/view_document', obj, { responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    if (resp) {
      return resp;
    }
    return
  }

  async view_admin_report(obj :any) {
    console.log(obj, "from service")
    const resp = await this.http.post(this.main.httpUrl2 + '/pet/admin_reg/view_admin_report', obj, { responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    if (resp) {
      return resp;
    }
    return
  }






  async changeDemandStatus(obj :any)  {
    const resp = this.http.post<any>(this.main.httpUrl2  + '/pet/admin_reg/changeDemandStatus' , obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async penalty_list(obj:any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/pet/admin_reg/penalty_list' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async manage_penalty(obj :any)  {
    const resp = this.http.put<any>(this.main.httpUrl2  + '/pet/admin_reg/manage_penalty' , obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async compaint_penalty(obj :any)  {
    const resp = this.http.post<any>(this.main.httpUrl2  + '/pet/admin_reg/create_complaint_penatlty' , obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async recive_penalty(obj :any)  {
    const resp = this.http.put<any>(this.main.httpUrl2  + '/pet/admin_reg/recive_penalty' , obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async getpenalty_byparty(obj :any)  {
    const resp = this.http.get<any>(this.main.httpUrl2  + '/pet/admin_reg/list_ATPP' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async revoke_registration(obj :any)  {
    const resp = this.http.put<any>(this.main.httpUrl2  + '/pet/admin_reg/revoke_registration' , obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async revoke_reg_complaint_by_cancilation(obj :any)  {
    const resp = this.http.put<any>(this.main.httpUrl2  + '/pet/admin_reg/revoke_cancled_by_complaint' , obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async cmp_revoke(obj :any)  {
    const resp = this.http.post<any>(this.main.httpUrl2  + '/pet/registration/renewal', obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async create_rule(obj :any)  {
    const resp = this.http.post<any>(this.main.httpUrl2  + '/pet/admin_reg/penalty_rule_create', obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async get_rule(obj :any)  {
    const resp = this.http.get<any>(this.main.httpUrl2  + '/pet/admin_reg/get_penalty_rule' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async notification(obj :any)  {
    const resp = this.http.get<any>(this.main.httpUrl2  + '/pet/admin_reg/notification_log' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async update_notification(obj :any)  {
    const resp = this.http.post<any>(this.main.httpUrl2  + '/pet/admin_reg/update_notification' , obj).toPromise().then(res => {
      return res
    });
    return resp
  }
// ////////////////////send msg ////////////////////
async send_msg(obj :any)  {
  const resp = this.http.post<any>(this.main.httpUrl2  + '/pet/admin_reg/sendNotification' , obj).toPromise().then(res => {
    return res
  });
  return resp
}
async approved_license(obj :any)  {
  const resp = this.http.post<any>(this.main.httpUrl2  + '/pet/admin_reg/approved_license', obj).toPromise().then(res => {
    return res
  });
  return resp
}
async reject_license(obj :any)  {
  const resp = this.http.post<any>(this.main.httpUrl2  + '/pet/admin_reg/reject_license', obj).toPromise().then(res => {
    return res
  });
  return resp
}
}


// async insert_pdi_request(obj :any) {
//   obj['gateway_id'] = this.main.vendor_g_id
//   const resp = await this.http.post<any>(this.main.httpUrl + '/vendor/pdi_request' ,this.mds.dataE(obj),).toPromise().then(res => {
//     return res;
//   });
//   return resp;
// }

// async get_bill_request(obj :any) {
//   obj['gateway_id'] = this.main.vendor_g_id
//   const resp = await this.http.get<any>(this.main.httpUrl + '/vendor/get_all_billrequest' + JSON.stringify({}),{
//       headers:
//         new HttpHeaders().append('data',await this.mds.dataE(obj))
//     }).toPromise().then(async res => {
//       return await this.mds.dataD(res);
//     });
//   return resp;
// }